import React from 'react';

import { BrandValue } from './types';

const BrandContext = React.createContext<BrandValue>({
  isCoBranded: null,
  appBrandTitle: null,
  defaultColors: null,
  primaryBrand: {
    id: -1,
    name: '',
    placement: 'primary',
  },
  coBrand: null,
  coBrandUrl: null,
  lbBrand: null,
  isValidBrand: null,
  fetchCoBrand: null,
  getColors: null,
  setCoBrandUrl: null,
  setPrimaryBrand: null,
});

export default BrandContext;
